<!--
 * @Description: 传入record数据，通过判断record.type，来渲染对应的组件
 * @Author: kcz
 * @Date: 2020-01-02 22:41:48
 * @LastEditors: kcz
 * @LastEditTime: 2022-10-28 22:55:07
 -->
<template>
  <component v-if="record.options.noFormItem" v-bind="getComponentProps" @hook:mounted="childMounted"
    :is="componentItem"></component>
  <!-- 可隐藏label -->
  <a-form-item v-else :label-col="formConfig.layout === 'horizontal' &&
    isShowLabel(record.options.showLabel)
    ? formConfig.labelLayout === 'flex'
      ? { style: `width:${formConfig.labelWidth}px` }
      : formConfig.labelCol
    : {}
    " :wrapper-col="formConfig.layout === 'horizontal' &&
      isShowLabel(record.options.showLabel)
      ? formConfig.labelLayout === 'flex'
        ? { style: 'width:auto;flex:1' }
        : formConfig.wrapperCol
      : {}
      " :style="formConfig.layout === 'horizontal' &&
        formConfig.labelLayout === 'flex' &&
        isShowLabel(record.options.showLabel)
        ? { display: 'flex' }
        : {}
        ">
    <span slot="label" v-if="isShowLabel(record.options.showLabel)">
      <span v-if="currentEditType === 'label'" class="focusable-input">
        <a-input ref="labelInput" v-model="record.sequence" style="width: 10%; margin-right: 5px;"
          @blur="handleAllBlurred" />
        <a-input ref="labelInput2" v-model="record.label" style="width: 60%;" @blur="handleAllBlurred" />
        <a @click.stop="editSave" style="margin: 0px 10px">保存</a>
        <a @click.stop="editCancel">取消</a>
      </span>
      <span v-else style="width: 90%;display: inline-block;">
        <a-tooltip>
          <span v-if="record.help" slot="title" v-html="record.help"></span>
          <a-icon v-if="record.help" class="question-circle" style="vertical-align: top;margin-top: 7px;"
            type="question-circle-o" />
          <span v-text="record.sequence + ' ' + record.label" class="option-label" @click="labelEdit"></span>
        </a-tooltip>
      </span>
    </span>
    <div v-if="record.img" style="width:180px; padding: 10px;">
      <img :src="getAvatarView()" style="width:100%;height:100%" />
    </div>
    <!-- 单独处理 -->
    <template v-if="isRadioOrCheckbox">
      <!-- 自定义radio组件 -->
      <a-radio-group v-if="record.type === 'radio'" :disabled="true">
        <a-radio v-for="(option, index) in record.options.options" :key="index" :value="option.value"
          class="editable-option">
          <span class="option-container">
            <span v-if="currentEditType === 'option' && editingOptionIndex === index && isSelected()"
              class="option-editor">
              <span class="option-input">
                <Input ref="optionInput" v-model="option.label" class="a-input" @blur="handleOptionBlur" />
                <a-tag color="green" v-if="option.defaultValue" style="margin-left: 5px;">默认选项</a-tag>
              </span>
            </span>
            <span v-else class="option-label" @click.stop="optionEdit(index)">
              <span class="label">
                {{ option.label }}
                <a-tag color="green" v-if="option.defaultValue" style="margin-left: 5px;">默认选项</a-tag>
              </span>
            </span>
            <a-icon type="delete" class="delete-icon" @click.stop="handleDelete(index)"
              v-if="record.options.options.length > 1 && isSelected()" />
          </span>
        </a-radio>
      </a-radio-group>
      <!-- 自定义checkbox组件 -->
      <a-checkbox-group v-else-if="record.type === 'checkbox'" :disabled="true">
        <a-checkbox v-for="(option, index) in record.options.options" :key="index" :value="option.value"
          class="editable-option">
          <span class="option-container">
            <span v-if="currentEditType === 'option' && editingOptionIndex === index && isSelected()"
              class="option-editor">
              <span class="option-input">
                <Input ref="optionInput" v-model="option.label" class="a-input" @blur="handleOptionBlur" />
                <a-tag color="green" v-if="option.defaultValue" style="margin-left: 5px;">默认选项</a-tag>
              </span>
            </span>
            <span v-else class="option-label" @click.stop="optionEdit(index)">
              <span class="label">
                {{ option.label }}
                <a-tag color="green" v-if="option.defaultValue" style="margin-left: 5px;">默认选项</a-tag>
              </span>
            </span>
            <a-icon type="delete" class="delete-icon" @click.stop="handleDelete(index)"
              v-if="record.options.options.length > 1 && isSelected()" />
          </span>
        </a-checkbox>
      </a-checkbox-group>
    </template>
    <component :class="['o-component', { 'focusable-input': record.isTableCell }]" v-else :is="componentItem" v-bind="getComponentProps" @hook:mounted="childMounted"
      ref="inputItem" @change="handleChange" v-decorator="[
        record.model, // input 的 name
        {
          initialValue: record.options.defaultValue, // 默认值
          valuePropName: record.type === 'switch' ? 'checked' : 'value',
          rules: record.rules // 验证规则
        }
      ]"></component>
    <!--  -->
  </a-form-item>
</template>
<script>
/*
 * author kcz
 * date 2019-11-20
 */
import { pluginManager, lazyLoadTick } from "../../utils/index";
import { getFileAccessHttpUrl } from '@/api/manage'
const _ = require("lodash/object");
const ComponentArray = pluginManager.getComponents();
const Input = pluginManager.getComponent("input").component;
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: "KFormItem",
  props: {
    // 表单数组
    record: {
      type: Object,
      required: true
    },
    // form-item 宽度配置
    formConfig: {
      type: Object,
      required: true
    },
    config: {
      type: Object,
      default: () => ({})
    },
    dynamicData: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    },
    selectItem: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    Input
  },
  data() {
    return {
      editable: false,
      preSequence: "",
      preLabel: "",
      editingOptionIndex: -1, // 当前正在编辑的选项索引
      preOptionLabel: "", // 选项编辑前的值
      currentEditType: null, // 当前编辑类型：'label' 或 'option'
    };
  },
  computed: {
    /**
     * 计算组件props
     */
    /**
   * 判断是否为radio或checkbox类型
   */
    isRadioOrCheckbox() {
      return ['radio', 'checkbox'].includes(this.record.type);
      // return false
    },
    getComponentProps() {
      const record = this.record;

      if (this.record.rules && this.record.rules.length > 0) {
        this.record.rules.map(item => {
          if (typeof item.required !== "undefined") {
            item.required = record.required;
          }
        });
      }

      const componentProps = {
        record,
        ...this.componentOption,
        config: this.config,
        disabled: this.disabled || record.options.disabled,
        parentDisabled: this.disabled || record.options.disabled,
        allowClear: record.options.clearable,
        mode: record.options.multiple ? "multiple" : "",
        style: `width:${record.options.width}`,
        height:
          typeof record.options.height !== "undefined"
            ? record.options.height
            : "",
        dynamicData: this.dynamicData,
        options: !record.options.dynamic
          ? record.options.options
          : this.dynamicData[record.options.dynamicKey]
            ? this.dynamicData[record.options.dynamicKey]
            : []
      };

      if (this.record.type === "textarea") {
        componentProps.autoSize = {
          minRows: record.options.minRows,
          maxRows: record.options.maxRows
        };
      }

      if (this.record.type === "input"|| this.record.type === "textarea") {
        // 表格单元格可以编辑
        if (!this.record.isTableCell) {
          componentProps.readOnly = true;
          componentProps.tabindex = '-1';
          componentProps.disabled = true;
        }
      }

      if (this.record.type === "alert") {
        componentProps.message = record.label;
      }

      if (this.record.type === "treeSelect") {
        componentProps.treeData = !record.options.dynamic
          ? record.options.options
          : this.dynamicData[record.options.dynamicKey]
            ? this.dynamicData[record.options.dynamicKey]
            : [];
      }

      if (this.record.type === "number" || this.record.type === "knumber") {
        componentProps.min =
          record.options.min || record.options.min === 0
            ? record.options.min
            : -Infinity;

        componentProps.max =
          record.options.max || record.options.max === 0
            ? record.options.max
            : Infinity;

        componentProps.precision =
          record.options.precision > 50 ||
            (!record.options.precision && record.options.precision !== 0)
            ? null
            : record.options.precision;

        if (record.options.unit) {
          componentProps.formatter = (value) => `${value} ${record.options.unit}`;
        }
      }

      if (this.record.type === "select") {
        componentProps.filterOption = record.options.showSearch
          ? (inputValue, option) => {
            return (
              option.componentOptions.children[0].text
                .toLowerCase()
                .indexOf(inputValue.toLowerCase()) >= 0
            );
          }
          : false;
      }

      if (this.record.type === "button") {
        componentProps.onHandleReset = () => this.$emit("handleReset");
      }

      return componentProps;
    },
    /**
     * @description: 输出对应组件
     * @param {*}
     * @return {*} component
     */

    componentItem() {
      let recordType = this.record.type;
      if (recordType === 'selectCard') {
        recordType = 'radio';
      }
      if (recordType === 'dateyear') {
        recordType = 'date';
      }
      if (recordType === 'hour' || recordType === 'minute') {
        recordType = 'time';
      }

      const componentDef = ComponentArray[recordType];
      return componentDef ? componentDef.component : null;
    },
    componentOption() {
      // 移除相应字段
      const options = _.omit(this.record.options, ["defaultValue", "disabled"]);
      return options;
    }
  },
  methods: {
    ...mapActions(["setDisable"]),
    // 判断是否选中
    isSelected() {
      return this.selectItem.key === this.record.key
    },
    // 判断isShowLabel === false兼容低版本处理
    isShowLabel(v) {
      return String(v) !== "false";
    },
    validationSubform() {
      // 验证动态表格
      if (["batch", "selectInputList"].includes(this.record.type)) {
        if (!this.$refs.inputItem) return true;
        return this.$refs.inputItem.validationSubform();
      }

      return true;
    },
    handleChange(e) {
      let value = e;
      if (e && e.target) {
        value = e.target.value;
      }
      // 传递change事件
      this.$emit("change", value, this.record.model);
    },
    handleDelete(deleteIndex) {
      const addData = this.record.options.options.filter((val, index) => index !== deleteIndex)
      // 删除
      this.$emit(
        "input",
        addData
      );

      this.$emit('refreshOptions')
    },
    childMounted() {
      let recordType = this.record.type;
      if (recordType === 'selectCard') {
        recordType = 'radio';
      }

      // 记录已加载组件
      this.$nextTick(() => {
        lazyLoadTick.countLoaded(recordType);
      });
    },
    // 判断是否是当前选中项，能否进行编辑
    async isActived() {
      if (this.isSelected()) {
        return true
      } else {
        console.log('isActived----')
        this.$emit("handleSetSelectItem")
        await this.$nextTick()
      }
    },
    // 点击编辑
    labelEdit() {
      console.log('labelEdit')
      if (!this.isActived()) return

      let that = this;

      // 如果正在编辑其他内容，先保存
      if (this.currentEditType === 'option') {
        this.editSave()
      }

      if (this.editable && this.currentEditType === 'label') {
        return;
      }

      this.preSequence = this.record.sequence;
      this.preLabel = this.record.label;

      this.editable = true;
      this.currentEditType = 'label';
      this.$nextTick(() => {
        this.$store.dispatch('setDisable', false);
        that.$refs.labelInput.focus();
      });
    },
    // 点击编辑选项
    optionEdit(index) {
      if (!this.isActived()) return

      // 如果正在编辑其他内容，先保存
      if (this.currentEditType === 'label') {
        this.editSave()
      }

      if (this.editingOptionIndex === index && this.currentEditType === 'option') {
        return;
      }

      this.editingOptionIndex = index
      this.preOptionLabel = this.record.options.options[index].label;
      this.currentEditType = 'option';

      this.$nextTick(() => {
        this.$store.dispatch('setDisable', false);
        if (this.$refs.optionInput) {
          this.$refs.optionInput[0].focus()
        }
      })
    },
    // 取消
    editCancel() {
      if (this.currentEditType === 'label') {
        this.record.sequence = this.preSequence;
        this.record.label = this.preLabel;
      }
      this.editable = false;
      this.editingOptionIndex = -1;
      this.currentEditType = null;
    },
    // 保存
    editSave() {
      this.editable = false;
      this.editingOptionIndex = -1;
      this.preOptionLabel = "";
      this.currentEditType = null;
    },
    // 手动检查焦点状态
    checkFocus() {
      // 检查label输入框焦点
      if (this.currentEditType === 'label' && this.$refs.labelInput && this.$refs.labelInput.$el && document.activeElement === this.$refs.labelInput.$el) {
        return true;
      }
      if (this.currentEditType === 'label' && this.$refs.labelInput2 && this.$refs.labelInput2.$el && document.activeElement === this.$refs.labelInput2.$el) {
        return true;
      }

      // 检查选项输入框焦点
      if (this.currentEditType === 'option' && this.$refs.optionInput) {
        return (this.$refs.optionInput || []).some(input => {
          return input && input.$el && document.activeElement === input.$el;
        });
      }

      return false;
    },
    // 离开焦点
    handleAllBlurred(e) {
      console.log('handleAllBlurred1 this.checkFocus()：' + this.checkFocus());
      // 延迟处理，确保焦点确实已经离开
      setTimeout(() => {
        console.log('handleAllBlurred2 this.checkFocus()：' + this.checkFocus());
        if (!this.checkFocus()) {
          if (!(this.$refs.labelInput || this.$refs.labelInput2)) {
            this.$store.dispatch('setDisable', false)
          }
          this.editSave();
        }
      }, 100);
    },
    // 离开焦点 - 处理选项编辑
    handleOptionBlur(e) {
      // 延迟处理，确保焦点确实已经离开
      setTimeout(() => {
        console.log('handleOptionBlur this.checkFocus()：' + this.checkFocus());
        if (!this.checkFocus()) {
          this.$store.dispatch('setDisable', false)
          this.editSave()
        }
      }, 100)
    },

    // 获取图片预览地址
    getAvatarView() {
      if (this.record.img) {
        return getFileAccessHttpUrl(this.record.img)
      }
    },
  },
  created() {
    let recordType = this.record.type;
    if (recordType === 'selectCard') {
      recordType = 'radio';
    }

    // 记录待加载组件
    lazyLoadTick.countlazyLoad(recordType);
  }
};
</script>
<style lang="less" scoped>
.focusable-input {
  /* input元素恢复鼠标事件 */
  pointer-events: auto !important;
}

/deep/ .ant-input[disabled] {
  background-color: #fff !important;
}

.o-component {
  pointer-events: none;
}

.ant-checkbox-group,
.ant-radio-group {
  width: 100%;
}

/* 可编辑选项样式 */
.editable-option {
  width: 100%;
  margin-bottom: 8px;
  margin-left: 8px;
  padding: 0 18px 0 10px;

  .option-container {
    display: inline-block;
    width: calc(100% - 50px);
    white-space: nowrap;

    .delete-icon {
      color: #f5222d;
      cursor: pointer;
      pointer-events: auto;
      font-size: 16px;
      transition: color 0.3s;
      margin-left: 5px;
      display: none;

      &:hover {
        display: inline-block;
        color: #cf1322;
      }
    }

    &:hover {
      .delete-icon {
        display: inline-block;
      }

      .option-label {
        border: 1px dashed #007aff;
      }
    }
  }
}

.option-label {
  cursor: pointer;
  display: inline-block;
  padding: 2px 4px;
  border-radius: 2px;
  pointer-events: auto;
  transition: background-color 0.2s;
  width: calc(100% - 20px);
  border: 1px dashed transparent;

  .label {
    flex: 1;
  }
}

.option-editor {
  display: inline-block;
  pointer-events: auto;
  width: calc(100% - 20px);

  .option-input {
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center;
    gap: 5px;

    .a-input {
      height: 30px;
    }
  }
}
</style>
